import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class SizeSelect extends Icon {
  render() {
    let { color, style, viewPortSize, width, height } = this.props;

    return (
      <svg
       width={width}
       style={style}
       height={height}
       x="0px"
       y="0px"
       version="1.1"
       xmlns="http://www.w3.org/2000/svg"
       viewBox={'0 0 24 24'}>
        <g fill={color}>
          <path d="M21,15H23V17H21V15M21,11H23V13H21V11M23,19H21V21C22,21 23,20 23,19M13,3H15V5H13V3M21,7H23V9H21V7M21,3V5H23C23,4 22,3 21,3M1,7H3V9H1V7M17,3H19V5H17V3M17,19H19V21H17V19M3,3C2,3 1,4 1,5H3V3M9,3H11V5H9V3M5,3H7V5H5V3M1,11V19A2,2 0 0,0 3,21H15V11H1M3,19L5.5,15.79L7.29,17.94L9.79,14.72L13,19H3Z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/SizeSelect.js